module.exports = __webpack_public_path__ + "img/tag_vip.9ce1cf18.png";